export default __webpack_public_path__ + "static/icon2-7e46a7c2fec6eabda307b24eada5498a.png";